import React, { useState, useMemo } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { CSVLink } from "react-csv";
import { FiClock, FiCheckCircle, FiXCircle, FiFolder } from "react-icons/fi";
import { Link } from "react-router-dom";

function ManageCategory() {
  // Sample category data
  const [categories, setCategories] = useState([
    {
      id: 1,
      categoryName: "Electronics",
      status: "Active",
      createdAt: "2025-08-01",
    },
    {
      id: 2,
      categoryName: "Fashion",
      status: "Inactive",
      createdAt: "2025-08-05",
    },
    {
      id: 3,
      categoryName: "Home & Kitchen",
      status: "Active",
      createdAt: "2025-08-10",
    },
  ]);

  const [filters, setFilters] = useState({
    search: "",
    dateFrom: null,
    dateTo: null,
  });

  const [showFilter, setShowFilter] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleDateChange = (name, date) => {
    setFilters({ ...filters, [name]: date[0] });
  };

  // Filter categories
  const filteredCategories = useMemo(() => {
    return categories
      .filter((c) => {
        const matchesSearch = c.categoryName
          .toLowerCase()
          .includes(filters.search.toLowerCase());

        const matchesDate =
          (!filters.dateFrom || new Date(c.createdAt) >= filters.dateFrom) &&
          (!filters.dateTo || new Date(c.createdAt) <= filters.dateTo);

        return matchesSearch && matchesDate;
      });
  }, [categories, filters]);

  // Pagination
  const indexOfLast = currentPage * rowsPerPage;
  const indexOfFirst = indexOfLast - rowsPerPage;
  const currentCategories = filteredCategories.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredCategories.length / rowsPerPage);

  // Report Summary
  const reportSummary = {
    totalCategories: categories.length,
    activeCategories: categories.filter((c) => c.status === "Active").length,
    inactiveCategories: categories.filter((c) => c.status === "Inactive").length,
  };

  return (
    <>
      <Topbar />
      <Sidebar />
      <main className="main-wrapper">
        <div className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="breadcrumb-title">Manage Categories</h4>
            <div>

<Link className="btn btn-primary me-2" to="/category-builder">Add Category</Link>

              <button
                className="btn btn-primary me-2"
                onClick={() => setShowFilter(true)}
              >
                Filters
              </button>
              <CSVLink
                data={filteredCategories}
                filename={"categories.csv"}
                className="btn btn-primary"
              >
                Export CSV
              </CSVLink>
            </div>
          </div>

          {/* Report Summary */}
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
                <FiFolder size={30} className="text-primary" />
                <div className="kpi-content ms-3">
                  <h6>Total Categories</h6>
                  <h2>{reportSummary.totalCategories}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
                <FiCheckCircle size={30} className="text-success" />
                <div className="kpi-content ms-3">
                  <h6>Active Categories</h6>
                  <h2>{reportSummary.activeCategories}</h2>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="kpi-card bg-soft-primary d-flex align-items-center p-3">
                <FiXCircle size={30} className="text-danger" />
                <div className="kpi-content ms-3">
                  <h6>Inactive Categories</h6>
                  <h2>{reportSummary.inactiveCategories}</h2>
                </div>
              </div>
            </div>
          </div>

          {/* Categories Table */}
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body table-responsive">
                <table className="table table-hover table-striped align-middle">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Category Name</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentCategories.map((c) => (
                      <tr key={c.id}>
                        <td>{c.id}</td>
                        <td>{c.categoryName}</td>
                        <td>
                          <span
                            className={`badge ${
                              c.status === "Active"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {c.status}
                          </span>
                        </td>
                        <td>{c.createdAt}</td>
                        <td>
                          <div className="d-flex gap-1 flex-wrap">
                            <button className="btn btn-sm btn-primary">Edit</button>
                            <button className="btn btn-sm btn-danger">Delete</button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Rows per page:{" "}
                    <select
                      value={rowsPerPage}
                      onChange={(e) => {
                        setRowsPerPage(Number(e.target.value));
                        setCurrentPage(1);
                      }}
                    >
                      {[5, 10, 20, 50].map((n) => (
                        <option key={n} value={n}>
                          {n}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                      (page) => (
                        <button
                          key={page}
                          className={`btn btn-sm ${
                            currentPage === page
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } mx-1`}
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Panel */}
          <div className={`filter-panel ${showFilter ? "open" : ""}`}>
            <div className="filter-header">
              <h5>Filters</h5>
              <button
                className="btn-close"
                onClick={() => setShowFilter(false)}
              ></button>
            </div>
            <div className="filter-body">
              <div className="mb-3">
                <label>Search Category</label>
                <input
                  type="text"
                  className="form-control"
                  name="search"
                  placeholder="Category name"
                  value={filters.search}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="mb-3">
                <label>Created From</label>
                <Flatpickr
                  value={filters.dateFrom}
                  onChange={(date) => handleDateChange("dateFrom", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <div className="mb-3">
                <label>Created To</label>
                <Flatpickr
                  value={filters.dateTo}
                  onChange={(date) => handleDateChange("dateTo", date)}
                  options={{ dateFormat: "Y-m-d" }}
                  className="form-control"
                />
              </div>
              <button
                className="btn btn-primary w-100"
                onClick={() => setShowFilter(false)}
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default ManageCategory;
